
// import React, { createContext, useContext, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { User } from "../Types/User";
// type AuthContextType = {
//   user: User | null | undefined;
//   signIn: (email: string, password: string) => Promise<boolean>;
//   signOut: () => void;
//   setUser: React.Dispatch<React.SetStateAction<User | null| undefined>>;
// };
// const url = process.env.REACT_APP_API_URL;
// const UserContext = createContext<AuthContextType | undefined>(undefined);

// // ----------------------------
// //  SAFE JSON PARSER
// // ----------------------------
// async function safeJson(res: Response) {
//   try {
//     const text = await res.text();
//     return text ? JSON.parse(text) : null;
//   } catch {
//     return null;
//   }
// }

// export const UserProvider = ({ children }: { children: React.ReactNode }) => {
// const [user, setUser] = useState<User | null | undefined>(undefined);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   // ----------------------------
//   // LOAD USER ON STARTUP
//   // ----------------------------
//   // const loadUser = async () => {
//   //   try {
//   //     const res = await fetch(`${url}/Auth/me`, {
//   //       credentials: "include"
//   //     });

//   //     if (!res.ok) {
//   //       setUser(null);
//   //       return;
//   //     }

//   //     const data = await safeJson(res);
//   //     if (data) setUser(data);
//   //     else setUser(null);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };
// const loadUser = async () => {
//   try {
//     let res = await fetch(`${url}/Auth/me`, {
//       credentials: "include"
//     });

//     if (res.status === 401) {
//       const refreshRes = await fetch(`${url}/Auth/refresh`, {
//         method: "POST",
//         credentials: "include"
//       });

//       if (!refreshRes.ok) {
//         setUser(null);
//         navigate('/sign-in')

//         return;
//       }

//       res = await fetch(`${url}/Auth/me`, {
//         credentials: "include"
//       });
//     }

//     if (!res.ok) {
//       setUser(null);
//       return;
//     }

//     const data = await safeJson(res);
//     setUser(data ?? null);
//   } finally {
//     setLoading(false);
//   }
// };

// useEffect(() => {
//   const boot = async () => {
//     await new Promise(r => setTimeout(r, 50));
//     loadUser();
//   };
//   boot();
// }, []);
 

//   // ----------------------------
//   // SIGN IN
//   // ----------------------------
//   const signIn = async (email: string, password: string) => {
//     const loginRes = await fetch(`${url}/Auth/login`, {
//       method: "POST",
//       credentials: "include",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ email, password })
//     });

//     if (!loginRes.ok) {
//       return false;
//     }

//     // Låt cookies hinna synkas
//     await new Promise((res) => setTimeout(res, 100));

//     const meRes = await fetch(`${url}/Auth/me`, {
//       credentials: "include"
//     });

//     if (!meRes.ok) {
//       setUser(null);
//       return false;
//     }

//     const profile = await safeJson(meRes);
//     setUser(profile);

//     // Liten delay för stabil navigation
//     await new Promise((res) => setTimeout(res, 50));

//     if (profile.roles.includes("admin")) navigate("/admin");
//     else if (profile.roles.includes("courseowner")) navigate("/courses");
//     else if (profile.roles.includes("member")) navigate("/member-home");

//     return true;
//   };

//   // ----------------------------
//   // AUTO REFRESH TOKEN EVERY 10 MIN
//   // ----------------------------
//   // useEffect(() => {
//   //   const interval = setInterval(() => {
//   //     fetch(`${url}/Auth/refresh`, {
//   //       method: "POST",
//   //       credentials: "include"
//   //     });
//   //   }, 10 * 60 * 1000);

//   //   return () => clearInterval(interval);
//   // }, []);
// //   useEffect(() => {
// //   const interval = setInterval(async () => {
// //     const res = await fetch(`${url}/Auth/refresh`, {
// //       method: "POST",
// //       credentials: "include"
// //     });

// //     if (res.ok) {
// //       // 🔁 hämta nytt user-state
// //       const me = await fetch(`${url}/Auth/me`, {
// //         credentials: "include"
// //       });

// //       if (me.ok) {
// //         const profile = await safeJson(me);
// //         setUser(profile);
// //       }
// //     } else {
// //       //setUser(null);
// //     }
// //   }, 10 * 60 * 10000);

// //   return () => clearInterval(interval);
// // }, []);

//   // ----------------------------
//   // SIGN OUT
//   // ----------------------------
//   const signOut = async () => {
//     await fetch(`${url}/Auth/logout`, {
//       method: "POST",
//       credentials: "include"
//     });

//     setUser(null);
//     navigate("/sign-in");
//   };

//   if (loading || user === undefined) return <></>;

//   return (
//     <UserContext.Provider value={{ user, setUser, signIn, signOut }}>
//       {children}
//     </UserContext.Provider>
//   );
// };

// export const useUser = () => {
//   const ctx = useContext(UserContext);
//   if (!ctx) throw new Error("useUser must be used inside UserProvider");
//   return ctx;
// };
import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { User } from "../Types/User";
import { apiGet, refreshSession } from "./apiClient";


type AuthContextType = {
  user: User | null | undefined;
  signIn: (email: string, password: string, captchaToken: string) => Promise<boolean>;
  signOut: () => void;
  setUser: React.Dispatch<React.SetStateAction<User | null | undefined>>;
};

const API_URL = process.env.REACT_APP_API_URL;
const UserContext = createContext<AuthContextType | undefined>(undefined);

async function safeJson(res: Response) {
  try {
    const text = await res.text();
    return text ? JSON.parse(text) : null;
  } catch {
    return null;
  }
}

export const UserProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<User | null | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  /* =============================================================
     LOAD USER ON STARTUP — uses api pipeline
  ============================================================= */

  const loadUser = async () => {
    try {
      const me = await apiGet<User>("/Auth/me");
      setUser(me);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUser();
  }, []);

  useEffect(() => {
    if (!user) return;

    const interval = window.setInterval(() => {
      void refreshSession().then(refreshed => {
        if (!refreshed) {
          window.dispatchEvent(new Event("auth-session-expired"));
        }
      });
    }, 4 * 60 * 1000);

    return () => window.clearInterval(interval);
  }, [user]);

  /* =============================================================
     GLOBAL SESSION EXPIRED HANDLER
  ============================================================= */

  useEffect(() => {
    const handler = () => {
      setUser(null);
      const publicRoutes = [
        "/",
        "/sign-in",
        "/forgot-password",
        "/reset-password",
        "/freebie",
        "/contact",
        "/membership",
        "/membership/signup",
        "/rot/signup",
        "/rot/balance",
        "/courses",
        "/booking",
        "/samtal",
        "/about",
        "/privacy-policy",
        "/terms-of-service",
        "/unsubscribe",
      ];

      const isPublicRoute = publicRoutes.some(path => location.pathname === path || location.pathname.startsWith(`${path}/`));
      if (!isPublicRoute) {
        navigate("/sign-in");
      }
    };

    window.addEventListener("auth-session-expired", handler);
    return () => window.removeEventListener("auth-session-expired", handler);
  }, [location.pathname, navigate]);

  /* =============================================================
     SIGN IN
  ============================================================= */

  const signIn = async (email: string, password: string, captchaToken: string) => {
    const loginRes = await fetch(`${API_URL}/Auth/login`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password, captchaToken })
    });

    if (!loginRes.ok) return false;

    await new Promise(r => setTimeout(r, 50));

    try {
      const profile = await apiGet<User>("/Auth/me");
      setUser(profile);

      // if (profile.roles.includes("admin")) navigate("/admin");
      // else if (profile.roles.includes("courseowner")) navigate("/courses");
      // else navigate("/member-home");
      console.log('VIKTIGT PROFILE',profile)
      if (profile.roles.includes("admin")) {
  navigate("/admin");
} else {
  navigate("/member-home");
}
      return true;
    } catch {
      setUser(null);
      return false;
    }
  };

  /* =============================================================
     SIGN OUT
  ============================================================= */

  const signOut = async () => {
    await fetch(`${API_URL}/Auth/logout`, {
      method: "POST",
      credentials: "include"
    });

    setUser(null);
    navigate("/sign-in");
  };

  if (loading || user === undefined) return null;

  return (
    <UserContext.Provider value={{ user, setUser, signIn, signOut }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const ctx = useContext(UserContext);
  if (!ctx) throw new Error("useUser must be used inside UserProvider");
  return ctx;
};
